import React, { useState, useEffect } from 'react';
import { Menu } from 'antd';
import { 
  UserOutlined, 
  CarOutlined, 
  FileOutlined, 
  BarChartOutlined,
  AuditOutlined,
  MoneyCollectOutlined,
  CarFilled
} from '@ant-design/icons';
import { authService, ROLE_LEVELS } from '../../services/authService';
import styles from './SideNav.module.css';

const SideNav = ({ onMenuSelect, collapsed }) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [canAccessFinance, setCanAccessFinance] = useState(false);

  useEffect(() => {
    const checkPermissions = async () => {
      try {
        const adminAccess = await authService.canAccess(ROLE_LEVELS.ADMIN);
        const managerAccess = await authService.canAccess(ROLE_LEVELS.MANAGER);
        const financeAccess = await authService.canAccess(ROLE_LEVELS.FINANCE);
        console.log('SideNav - Admin access:', adminAccess);
        console.log('SideNav - Manager access:', managerAccess);
        console.log('SideNav - Finance access:', financeAccess);
        setIsAdmin(adminAccess);
        setCanAccessFinance(financeAccess);
      } catch (error) {
        console.error('SideNav - Permission check error:', error);
      }
    };
    checkPermissions();
  }, []);

  const menuItems = [
    {
      key: 'students',
      icon: <CarOutlined />,
      label: '学员管理',
    },
    {
      key: 'verification',
      icon: <AuditOutlined />,
      label: '审核管理',
      children: [
        {
          key: 'studentVerification',
          label: '学员审核'
        },
        {
          key: 'withdrawalVerification',
          label: '退证审核'
        },
        {
          key: 'documentation',
          label: '学员审档'
        }
      ]
    },
    {
      key: 'exams',
      icon: <FileOutlined />,
      label: '考试管理',
      children: [
        {
          key: 'examBooking',
          label: '考试预约'
        },
        {
          key: 'examHistory',
          label: '考试总览'
        },
        {
          key: 'studyProgress',
          label: '学时更新'
        }
      ]
    },
    // Show stats for everyone (not conditional anymore)
    {
      key: 'stats',
      icon: <BarChartOutlined />,
      label: '统计报表',
    },
    {
      key: 'expenses',
      icon: <MoneyCollectOutlined />,
      label: '日常支出',
    },
    // Only show user management for admin
    ...(isAdmin ? [{
      key: 'users',
      icon: <UserOutlined />,
      label: '用户管理',
    }] : [])
  ];

  return (
    <>
      <div className={styles.logoContainer}>
        <CarFilled className={styles.logoIcon} />
        {!collapsed && <span className={styles.logoText}>汇丰驾校</span>}
      </div>
      <Menu
        theme="dark"
        defaultSelectedKeys={['students']}
        mode="inline"
        items={menuItems}
        onClick={({ key }) => onMenuSelect(key)}
      />
    </>
  );
};

export default SideNav; 